/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TSaveChatMessagesHintsByOfferRequest,
  TSaveChatMessagesHintsByOfferModel,
  IMappers,
  TSaveChatMessagesHintsByOfferResponse,
  TSaveChatMessagesHintsByOfferResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createSaveChatMessagesHintsByOfferModel(
  parameters: TSaveChatMessagesHintsByOfferRequest,
): TSaveChatMessagesHintsByOfferModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'chats',
    pathApi: '/v1/save-chat-messages-hints-by-offer/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ISaveChatMessagesHintsByOfferOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TSaveChatMessagesHintsByOfferRequest;
}

export async function fetchSaveChatMessagesHintsByOffer<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ISaveChatMessagesHintsByOfferOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TSaveChatMessagesHintsByOfferResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createSaveChatMessagesHintsByOfferModel(parameters),
    config,
  )) as FetchResponse<TSaveChatMessagesHintsByOfferResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TSaveChatMessagesHintsByOfferResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TSaveChatMessagesHintsByOfferResponse>;
}
